import React, { useState } from 'react';

const AdminAddProject = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title_ar: '', title_en: '',
    desc_ar: '', desc_en: '',
    image_url: '', category_ar: '',
    category_en: '', date: new Date().toISOString().split('T')[0]
  });


  const PROJECTS_API = 'https://www.yam-ii.com/yam_api/manage_projects.php';

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // منع تكرار الضغط
    setLoading(true);

    try {
      const response = await fetch(`${PROJECTS_API}?action=add_project`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      // إذا لم يكن الرد بصيغة JSON أو فشل الطلب
      if (!response.ok) throw new Error("Server Error");

      const result = await response.json();
      if (result.success) {
        alert("تم إضافة المشروع/الخبر بنجاح ✅");
        setFormData({
          title_ar: '', title_en: '',
          desc_ar: '', desc_en: '',
          image_url: '', category_ar: '',
          category_en: '', date: new Date().toISOString().split('T')[0]
        });
      } else {
        alert("خطأ: " + result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("حدث خطأ في الاتصال بالسيرفر، تأكد من ملف PHP");
    } finally {
      setLoading(false); // هذا السطر يضمن توقف الدوران في كل الحالات
    }
  };

  return (
    <div className="content-card">
      <div className="content-header">
        <h3>✨ إضافة مشروع أو خبر جديد</h3>
      </div>
      
      <form onSubmit={handleSubmit} style={styles.form}>
        {/* ... باقي حقول الفورم الخاصة بك كما هي ... */}
        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>العنوان بالعربية</label>
            <input type="text" name="title_ar" value={formData.title_ar} onChange={handleChange} style={styles.input} placeholder="مثال: تصدير شحنة جديدة" required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Title in English</label>
            <input type="text" name="title_en" value={formData.title_en} onChange={handleChange} style={styles.input} placeholder="Ex: New Shipment Export" required />
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>الوصف بالعربية</label>
            <textarea name="desc_ar" value={formData.desc_ar} onChange={handleChange} style={styles.textarea} placeholder="اكتب تفاصيل الخبر هنا..." required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Description in English</label>
            <textarea name="desc_en" value={formData.desc_en} onChange={handleChange} style={styles.textarea} placeholder="Write news details here..." required />
          </div>
        </div>

        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>اسم الصورة أو الرابط</label>
            <input type="text" name="image_url" value={formData.image_url} onChange={handleChange} style={styles.input} placeholder="مثال: project1.jpg" required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>التاريخ</label>
            <input type="date" name="date" value={formData.date} onChange={handleChange} style={styles.input} required />
          </div>
        </div>

        <button type="submit" className="refresh-btn" style={styles.submitBtn} disabled={loading}>
          {loading ? "جاري النشر..." : "نشر الخبر الآن 🚀"}
        </button>
      </form>
    </div>
  );
};

// ... الستايل الخاص بك ...
const styles = {
    form: { display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '10px' },
    row: { display: 'flex', gap: '20px', flexWrap: 'wrap' },
    field: { flex: 1, minWidth: '280px', display: 'flex', flexDirection: 'column', gap: '8px' },
    label: { fontSize: '14px', fontWeight: '600', color: '#4a5568' },
    input: { padding: '12px', borderRadius: '8px', border: '1px solid #edf2f7', backgroundColor: '#f8fafc', fontSize: '14px' },
    textarea: { padding: '12px', borderRadius: '8px', border: '1px solid #edf2f7', backgroundColor: '#f8fafc', fontSize: '14px', minHeight: '100px', resize: 'vertical' },
    submitBtn: { padding: '15px', marginTop: '10px', backgroundColor: '#1a3a5a', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px' }
};

export default AdminAddProject;